import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { ExcelMimeTypes, getDocTypeFromMimeType, PowerPointMimeTypes, WordMimeTypes } from '@tencent/docs-mime-types';
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { invokeMqq, MqqErrorName, MqqNamespace } from "../data-source/mqq";
export var CreateLocalFileRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(CreateLocalFileRequest, _DriveRequest);
  var _super = _createSuper(CreateLocalFileRequest);
  function CreateLocalFileRequest() {
    _classCallCheck(this, CreateLocalFileRequest);
    return _super.apply(this, arguments);
  }
  _createClass(CreateLocalFileRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return invokeMqq(payload);
            case 2:
              data = _context.sent;
              if (!data.err) {
                _context.next = 5;
                break;
              }
              throw new DriveApiError({
                name: MqqErrorName.UnknownMqqError,
                message: data.err,
                params: this.params,
                payload: payload,
                response: data.data
              });
            case 5:
              return _context.abrupt("return", data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      var mimeType = params.mimeType;
      var docType = getDocTypeFromMimeType(mimeType);
      var validMimeTypes = [].concat(_toConsumableArray(PowerPointMimeTypes), _toConsumableArray(ExcelMimeTypes), _toConsumableArray(WordMimeTypes));
      if (!validMimeTypes.includes(mimeType) || docType === undefined) {
        throw new DriveApiError({
          name: 'CreateLocalFileParamsError',
          message: "Cannot create local file of mimeType ".concat(mimeType, " because it's not support."),
          params: params,
          payload: null,
          response: null,
          context: {
            supports: validMimeTypes
          }
        });
      }
      return {
        namespace: MqqNamespace.Docx,
        methodName: 'createLocalFile',
        data: {
          docType: docType
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.err) {
        throw new DriveApiError({
          name: 'CreateLocalFileResponseError',
          message: response.err,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      return {
        url: response.url
      };
    }
  }]);
  return CreateLocalFileRequest;
}(DriveRequest);
//# sourceMappingURL=create-local-file.js.map